<template>
<div>
  <Modal
		transition-names
		class-name="modal-modify-the-odds" 
		footer-hide padding="25" :mask="false"
		v-model="modalshow" :transfer="false" 
    :transition-names="['load-top-fade', 'fade']"
    :styles="{top: '140px'}"
	>
    <div class="text-center" v-if="modalData">
			<p style="font-size: 1.2em;">修改:::{{$route.meta.title}}:::{{modalData.name}}:::</p>
			<Input ref="modifyOddsInput" v-model="modalData.trodds" class="my-3" @on-enter="FixOdds"></Input>
			<Button type="success" @click="FixOdds" class="mr-1">更新</Button>
			<Button type="error" @click="modalshow = !modalshow">取消</Button>
		</div>
  </Modal>
	<div v-show="modalshow" class="lida-mask"></div>
</div>
</template>
<script>
import { mapGetters } from 'vuex';
import NP from 'number-precision'
import checkpath from 'views/liveshow/mixins/checkPath'
export default {
  name: 'livshow-modal-modify-the-odds',
  mixins: [checkpath],
  data() {
    return {
			modalshow: false,
			modalData: null,
			default_chodd: null
    };
	},
	computed: {
		...mapGetters(['getliveshow', 'getmember', 'getgameid'])
	},
  mounted() {
    this.$Eventhub.$on("modify-liveshow-input-odds", pre => {
			this.modalshow = true;
			this.default_chodd = pre.trodds
      this.modalData = Object.assign({}, pre)
      this.$nextTick(() => {
        this.$refs['modifyOddsInput'].focus()
        this.$refs['modifyOddsInput'].$refs.input.select()
      })
    });
  },
  destroyed() {
    this.$Eventhub.$off("modify-liveshow-input-odds");
  },
  methods: {
		FixOdds() {
      if (this.modalData.trodds < 1) return this.$Message.error({ content: '赔率不可低于 1' })
      let defaultData = {
        chodd: NP.minus(this.modalData.trodds, this.default_chodd),
        odddtl: this.modalData.odddtl,
        troddid: this.modalData.troddid,
        trodds: this.default_chodd,
        porn: "1",
        baco: this.getliveshow.chgbaco,
        loid: this.getmember.pid,
      }
      const liveshow = 
        this.liveshowPath
          ? { mlevel: this.getmember.mlevel, reppid: '1' }
          : { stid: this.getliveshow.siteSelect, sp99: ['liveshowAll-scode'].includes(this.$route.name) && this.getliveshow.tema == 1 ? 1 : 0 }
      let data = Object.assign(defaultData, liveshow)
      if ([10, 11, 14, 15].includes(this.modalData.odddtl)) data['isIND'] = this.getliveshow.isdoubleOdds
      if (this.getliveshow.siteSelect == '') return
      this.PostfixOdds(data)
    },
    async PostfixOdds (data) {
      try {
        const res = 
          this.liveshowPath 
            ? await this.$axios.liveshow.fixBacoOddsPerson(this.getgameid, data)
            : await this.$axios.liveshow.linksupododup(this.getgameid, data)
        if(Array.isArray(res) && res[0].state == 0) {
          this.$Message.warning(res[0].msg);
          this.modalshow = !this.modalshow
          this.$Eventhub.$emit('alert-notice', [])
        } else { 
          if (res.status == 1) {
            this.$Message.success("修改成功");
            this.$emit("refresh");
            this.modalshow = !this.modalshow
            if(this.liveshowAllPath) {
              const item = Object.keys(res).filter(it => it != 'status').map(it => res[it])
              this.$Eventhub.$emit('alert-notice', item)
            }
          }
        }
        
      } catch (error) {
        // const index = this.liveshowPath ? 1 : 2
        // this.$Message.error(`网路异常：(S320${index})`);
      }
    },
	}
};
</script>
<style lang="scss">
.modal-modify-the-odds {
	.ivu-modal-content {
		border: 10px solid rgba(0,0,0,.7);
	}
	.ivu-modal-body {
		padding: 25px
	}
}
.lida-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: transparent;
  height: 100%;
  z-index: 100;
}
.load-top-fade-enter-active, 
.load-top-fade-leave-active {
  transition: all .3s ease-in-out;
}
.load-top-fade-enter {
  transform: translateY(-50px);
  opacity: 0;
}
.load-top-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
</style>